/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setBrandName} from '../api'

export const useMutationSetBrandName = createReactQueryMutationHook('setBrandName', setBrandName)
